import { CommonModule } from '@angular/common';
import { Component, effect, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CdTimerModule } from 'angular-cd-timer';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzInputDirective, NzInputGroupComponent, NzInputGroupWhitSuffixOrPrefixDirective } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzSelectComponent, NzOptionComponent } from 'ng-zorro-antd/select';
import { NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { UserService } from 'src/app/private/services/user.service';
import { SensorCardComponent } from '../../sensor-card/sensor-card.component';

@Component({
    selector: 'app-operators-history-dashboard',
    standalone: true,
    imports: [
        CommonModule,
        NzTableModule,
        FormsModule,
        NzFormModule,
        NzInputGroupComponent,
        NzIconDirective,
        NzInputGroupWhitSuffixOrPrefixDirective,
        NzInputDirective,
        CdTimerModule,
        NzProgressModule,
        NzToolTipModule,
    ],
    templateUrl: './operators-history-dashboard.component.html',
    styleUrl: './operators-history-dashboard.component.scss'
})
export class OperatorsHistoryDashboardComponent implements OnInit {
    private readonly userService = inject(UserService);
    private readonly toast = inject(NzMessageService);

    isLoading: boolean = true;
    usersActivityHistory: any[] = [];
    usersActivityHistoryFiltered: any[] = [];
    activeTab: string = 'operators-history';

    userFilter: string = '';
    startDateFilter: Date | undefined;
    endDateFilter: Date | undefined;

    totalUsers = signal(0);
    pageSize = signal(10);
    currentPage = signal(1);

    async ngOnInit() {
        this.isLoading = true;
        this.usersActivityHistory = (await this.userService.getUsersHistory()).userActivityHistories;
        this.usersActivityHistoryFiltered = [...this.usersActivityHistory];
        this.isLoading = false;
    }

    async onFilterChange() {
        try {
            if (this.startDateFilter && this.endDateFilter && this.startDateFilter > this.endDateFilter) {
                this.toast.error('La fecha de inicio no puede ser mayor que la fecha de fin.');
                return;
            }
            this.isLoading = true;
            const userActivityHistoriesResponse = await this.userService.getUsersHistory(
                this.userFilter,
                this.startDateFilter,
                this.endDateFilter,
                this.currentPage(),
                this.pageSize()
            )

            this.usersActivityHistoryFiltered = userActivityHistoriesResponse.userActivityHistories;
            this.totalUsers.set(userActivityHistoriesResponse.total);

        } catch (error) {
            this.toast.error('Error al filtrar el historial de actividad de los usuarios.');
        } finally {
            this.isLoading = false;
        }
    }

    async clearUserFilter() {
        this.userFilter = '';
        await this.onFilterChange();
    }

    onQueryParamsChange(params: NzTableQueryParams) {
        const { pageSize, pageIndex } = params;
        this.pageSize.set(pageSize);
        this.currentPage.set(pageIndex);
        this.onFilterChange();
    }
}
